export const taskCenter = {
  syrw: "始於任務，終於您",
  zjlbt: "Biking USDT贈金領不停",
  wdjj: "我的獎金",
  rwsm: "任務說明",
  rwlb: '任務清單',
  jljl: "獎勵記錄",
  klq: "可領取：",
  flzm: "Biking 福利之門",
  dcjl: "達成即領 USDT獎勵伴您一路前進",
  yjlq: "一鍵領取",
  lqcg: "領取成功",
  wdl: "未登入",
  jxz: "進行中",
  ylq: "已領取",
  rwjd: '任務進度',
  xsrw: '新手任務',
  hyrw: '合約任務',
  cjrz: '初級認證',
  gjrz: '高級認證',
  scbbjy: '首次幣幣交易',
  schyjy: '首次合約交易',
  sccz: '首次充值',
  schyhz: '首次合約劃轉',
  jyl: '交易量',
  ylje: '獲利金額',
  ksje: '虧損金額',
  dbkcbzj: '單筆開倉保證金',
  rjl: '入金量',
  dbczje: '單筆儲值金額',
  rwxq: '任務詳情'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/task/tw.js